import { XmlSchema } from './xmlSchema.class';

export class XmlSchemaLoader {
  public xmlSchema: XmlSchema;

  public constructor(schemaContent: string) {
    if (!schemaContent || schemaContent === '') {
      return;
    }
    const domparser = new DOMParser();
    const schemaDom = domparser.parseFromString(schemaContent, 'text/xml');
    // const rawElements = Array.from(schemaDom.documentElement.childNodes) as Element[];
    // this.xmlSchema = new XmlSchema(this.getXsdNodes(rawElements));

    let result: Node[] = [];
    const rawElementsAtRoot = Array.from(schemaDom.documentElement.childNodes) as Element[];
    rawElementsAtRoot.forEach(e => {
      const subChilds = this.getRawElements(e);
      result = result.concat(subChilds);
    });
    this.xmlSchema = new XmlSchema(this.getXsdNodes(result as Element[]));
  }

  private getRawElements(node: Node): Node[] {
    let result: Node[] = [];
    if (this.isValidXsdNode(node)) {
      result = result.concat(node);
    }

    const children = Array.from(node.childNodes) as Node[];
    children.forEach(child => {
      result = result.concat(this.getRawElements(child));
    });

    return result;
  }

  private isValidXsdNode(node: Node): boolean {
    const allowedXsdTypes = ['element', 'group', 'complexType'];
    const asElem = node as Element;

    if (asElem) {
      if (allowedXsdTypes.includes(asElem.localName)) {
        if (asElem.attributes.getNamedItem('name')) {
          // console.warn(asElem.attributes.getNamedItem('name').value);
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  private getXsdNodes(rawElements: Element[]) {
    // console.warn(rawElements.length);
    return new Map(rawElements.map<[string, Element]>(n => [n.attributes.getNamedItem('name').value, n as Element]));
  }
}
